import * as React from 'react';
import { createContext, ReactNode, useState } from 'react';
import { IAnsweredItem } from '@/types';

interface AnsweredItemsContextProps {
  children: ReactNode;
}

type AnsweredItemsContextData = {
  answeredItems: IAnsweredItem[];
  setAnsweredItems: (answeredItems: IAnsweredItem[]) => void;
};

export const AnsweredItemsContext = createContext<AnsweredItemsContextData>(
  {} as AnsweredItemsContextData
);

export function AnsweredItemsProvider({ children }: AnsweredItemsContextProps) {
  const [answeredItems, setAnsweredItems] = useState([] as IAnsweredItem[]);
  return (
    <AnsweredItemsContext.Provider
      value={{
        answeredItems: answeredItems,
        setAnsweredItems: setAnsweredItems,
      }}
    >
      {children}
    </AnsweredItemsContext.Provider>
  );
}
